module.exports = __webpack_public_path__ + "img/users.37d4c6a0.svg";